import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";

import TestPDF from "./TestPDF";
import { BACKEND } from "../../config/configEnvs";

const CotizacionPDF = () => {
  const { id } = useParams();

  const [cotizacionInfo, setCotizacionInfo] = useState(null);
  const [serviciosListData, setServiciosListData] = useState([]);
  const [pagosListData, setPagosListData] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    setIsLoading(true);
    getCotizacionInfo()
    console.log(cotizacionInfo);
  }, [id]);

  const getCotizacionInfo = async () => {
    await axios
      .get(`${BACKEND}/api/cotizaciones/${id}`)
      .then(({ data }) => setCotizacionInfo(data))
      .catch((e) => console.log(e))
  };

  const getPagos = async () => {
    await axios
      .get(`${BACKEND}/api/pagosCotizaciones?where[cotizacion][equals]=${id}`)
      .then(({ data }) => setPagosListData(data.docs))
      .catch((e) => console.log(e))
  };

  const getServicios = async () => {
    await axios
      .get(`${BACKEND}/api/serviciosCotizaciones?where[cotizacion][equals]=${id}`)
      .then(({ data }) => setServiciosListData(data.docs))
      .catch((e) => console.log(e))
  };

  return (
    <>
      {cotizacionInfo && (
        <div>
          <TestPDF  data={cotizacionInfo} />
          
        </div>
        
      )}
      xdxd
    </>
  );
};

export default CotizacionPDF;
